
import { AssignDiagnosticLessonsModel, AssignStudentDiagnosticLessonsModel, CreateDiagnosticVM, DiagnosticLessonsSkipStudentModel,
  UnassignDiagnosticLessonsVM,ViewWorkDataModel, ViewWorkDataVM, SubmitQuestionModel, SubmitViewWorkModel, 
  SubmitViewWorkResponseModel, UnAssignModel, ClassWithStudentsForListing, CreateAssignmentOptions, 
  CreateAssignmentsModel, CreateAccountModel, CurriculaVMModel, ExistingStudentCurriculumRegisterModel, 
  RegisterNewStudent, SelectedCurriculumModel, StudentModel, StudentCourseModel, CurriculumViewListing, 
  CurriculumProductLevelPrice, CurriculumProductLevel, PaymentProviderRequestResult, PaymentFailureRedirectModel, 
  PaymentSuccessRedirectModel, SelfServiceGetLessonModel, SelfGetLessonReturnModel, DemoRedirectModel, GetDemoRedirectModel, 
  LoginAccountModel, LoginAccountResult, ConsumerCurriculumJargon, DiagnosticReport, StudentConsumerCurriculum,
  LoginAsStudentModel,  DemoResultData,  EmailConfirmationModel, ExistingStudentConsumerCurriculumRegisterModel, DiagnosticReportRequest, StandardsGrowthReportModel, HasAlreadyPaidRedirectModel, ViewWorkDialogAssignmentAttempt, NotLoggedInReturnModel} from './../../Elearning-Models';


import { DiagnosticsDataService } from './../diagnosticsData.service';

import { DiagnosticsVM, DiagnosticVM, ReassignStudentModel, LessonProgressLockSaveModel, LessonProgressSaveGradeModel, LessonProgressSaveModel, LessonProgressReleaseAllByStudent,
  LessonProgressReleaseAllByAssignment, LessonProgressReleaseAllResult, DiagnosticsList, AssignAllDiagnosticModel,
   AssignStudentDiagnosticModel, DiagnosticSkipStudentModel, StudentForDiagnostic, DiagnosticRemoveFromSkipStudentModel } from 'src/app/Elearning-Models';
import { IAPIService } from './IAPIService';
import { Injectable } from '@angular/core';
import { Observable, of, TimeoutError } from 'rxjs';
import { ELearningDashboardClass, Teacher, Teachers, ELearningDashboardState, StudentLesson, Lesson, StudentVM, GradebookVM, AssignmentVM, ClassForListing } from '../../Elearning-Models';
import { TeacherData, TeacherNoClasses, AdminWithTeacherWithNoClassses, TeacherNoStudentsInClass, AdminWithTeacherWithNoStudentInClass, AdminNoTeachers, StudentLessons,
  AdminData, TeacherTEST } from '../mock-data';
import { IServiceFactory } from '../service-factory';
import { GradebookDataServiceMockValues, GradebookData, AssignmentData, StudentData, ClassListByStudentAndTeacherID, ClassListByTeacherID,
  StudentAndAssignmentData,
  CreateAssignment} from './MockValuesService/gradebookDataMockValues.service';
import { delay } from 'rxjs/operators';
import { DiagnosticsDataServiceMockValues } from './MockValuesService/diagnosticsDataMockValues.service';
import { ViewWorkDataServiceMockValues } from './MockValuesService/viewWorkDataMockValues.service';
import { CreateAccountServiceMockValues } from './MockValuesService/createAccountMockValues.service';
import { CurriculumServiceMockValues } from './MockValuesService/curriculumMockValues.service';
import { MockDemoResults } from './MockValuesService/demoResultMockData';
import { EmailConfirmationComponent } from 'src/app/layouts/curriculum/email-confirmation/email-confirmation.component';


@Injectable({
  providedIn: 'root'
})

export class APIServiceMock implements IAPIService{

  adminData: AdminData = new AdminData();

  teacherData: TeacherData = new TeacherData();

  isAdmin: boolean = false;

  gradebookData: GradebookData = new GradebookData();

  savedState: string = "{\"Collapsed\":[574996,574995,574997],\"StudentFilter\":1,\"Anchor\":200}";

  testsavedState: string = "{\"Collapsed\":[],\"StudentFilter\":1,\"Anchor\":784,\"TeacherID\":26678}";
  testData: TeacherTEST = new TeacherTEST();

  adminLinks: number[] = [1,2,3,4,5,6,7,8];

  studentLessons: StudentLessons = new StudentLessons();

  diagData: DiagnosticsDataServiceMockValues = new DiagnosticsDataServiceMockValues();

  constructor(){
  }
  HasAlreadyPaidByStudentConsumerCurrID(sccID: number): Observable<HasAlreadyPaidRedirectModel> {
    var model = new HasAlreadyPaidRedirectModel();
    model.ClassID = 1111;
    model.HasAlreadyPaid = false;
    return of(model);
  }
  HasAlreadyPaidByStudentClassID(studentID: number, classID: number): Observable<HasAlreadyPaidRedirectModel> {
    var model = new HasAlreadyPaidRedirectModel();
    model.ClassID = 1111;
    model.HasAlreadyPaid = false;
    return of(model);
  }

  IsLoggedIn():Observable<NotLoggedInReturnModel>{
    var loggedin = new NotLoggedInReturnModel();
    loggedin.LoggedIn = true;
    loggedin.LoginURL = "/Elearning/Login";

    var notloggedin = new NotLoggedInReturnModel();
    notloggedin.LoggedIn = false;
    notloggedin.LoginURL = '/ELearning/Login';
    return of(loggedin); 
  }

  CheckIsNewComer(): Observable<boolean>{
    return of(false);
  }


  ResendConfirmationEmail(guid: string):Observable<boolean>{
    return of(true).pipe(delay(3000));
  }

  ConfirmEmailByUser():Observable<EmailConfirmationModel>{
    var success = new EmailConfirmationModel();
    success.FullName = "Kyle Roberts";
    success.Success = true;

    var failure = new EmailConfirmationModel();
    failure.FullName = "Kyle Roberts";
    failure.Success = false;
    return of(success).pipe(delay(3000));
  }

  ConfirmEmail(guid: string):Observable<EmailConfirmationModel>{
    var success = new EmailConfirmationModel();
    success.FullName = "Kyle Roberts";
    success.Success = true;

    var failure = new EmailConfirmationModel();
    failure.FullName = "Kyle Roberts";
    failure.Success = false;
    return of(failure).pipe(delay(3000));
  }

  GetConsumerCurriculumJargon(): Observable<ConsumerCurriculumJargon>{
    var model = new ConsumerCurriculumJargon;
    model.DemoNoCaps = "diagnostic exam";
    model.DemoJustFirstLetterCaps = "Diagnostic exam";
    model.DemoAllFirstLetterCaps = "Diagnostic Exam";
    return of(model);
  }


  GetCurriculumProductLevelPrice(curriculumID: number): Observable<CurriculumProductLevelPrice[]> {
    var product1: CurriculumProductLevel = {
      ID: 1,
      Name: "Basic",
      Description: "<ul><li><b>15</b> Lessons Available</li><li><b>1</b> Diagnostic Test</li><li><b>1</b> Individualized Lesson Plan</li></ul>",
      Config: {
        HasLessonMax: true,
        LessonMax: 15
      }
    }

    var price1: CurriculumProductLevelPrice = {
      CurriculumProductLevelID: 1,
      DefaultPrice: 3999,
      ICurriculumProductLevel: product1,
      Active: true
    }

    var product2: CurriculumProductLevel = {
      ID: 2,
      Name: "Premium",
      Description: "<ul><li><b>-+</b> Lessons Available</li><li><b>Unlimited</b> Diagnostic Tests</li><li><b>Unlimited</b> Individualized Lesson Plans</li><li>Unit Tests</li><li>Standards Growth Report</li><li>Access to Entire Course</li></ul>",
      Config: {
        HasLessonMax: false,
        LessonMax: 0
      }
    }

    var price2: CurriculumProductLevelPrice = {
      CurriculumProductLevelID: 2,
      DefaultPrice: 7999,
      ICurriculumProductLevel: product2,
      Active: true
    }

    var levels = [price1,price2];

    return of (levels);
  }

  GetConsumerCurriculumDiagnosticReport(model: DiagnosticReportRequest): Observable<DiagnosticReport>{
    var cData = new MockDemoResults();
    return of(cData.demoReport);
  }

  GetDemoRedirect(model: GetDemoRedirectModel): Observable<DemoRedirectModel>{
    var m = new DemoRedirectModel();
    m.Success = false;
    return of(m).pipe(delay(3000));
  }

  ShowGradebookStudentAssignmentPagesCreateAssignmentInterfaces(){
    return of(false);
  }

  ValidateUserName(email:string):Observable<boolean>{
    return of(email != 'g@g.com');
  }
  UnassignOneOrAllAssignments(model: UnAssignModel): Observable<boolean>{
    return of(true);
  }
  UnassignDiagnosticLessons(model: UnassignDiagnosticLessonsVM): Observable<boolean> {
    return of(true);
  }
  CreateDiagnostic(model: CreateDiagnosticVM) : Observable<DiagnosticVM>
  {
    return of(this.diagData.diagnosticData).pipe(delay(500));
  }

  SubmitViewWorkData(model: SubmitViewWorkModel): Observable<SubmitViewWorkResponseModel> {
    return of({
      Graded: false,
      Success: true
    }).pipe(delay(500));
  }

  GetViewWorkData(model: ViewWorkDataModel): Observable<ViewWorkDataVM> {
    var mockViewWorkValues = new ViewWorkDataServiceMockValues();
    return of(mockViewWorkValues.viewWorkData).pipe(delay(500));
  }

  IsConsumerCurriculum():Observable<boolean>{
    return of(false);
  }

  AssignDiagnosticLessons(model: AssignDiagnosticLessonsModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  AssignStudentDiagnosticLessons(model: AssignStudentDiagnosticLessonsModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  DiagnosticRemoveFromLessonsSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  };

  DiagnosticRemoveFromSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  };

  DiagnosticSkipStudent(model: DiagnosticSkipStudentModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  AssignStudentDiagnostic(model: AssignStudentDiagnosticModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  AssignAllDiagnostic(model: AssignAllDiagnosticModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  GetSkippedStudentsList(diagExamID: number): Observable<StudentForDiagnostic[]> {
    var mockDiagnosticsValues = new DiagnosticsDataServiceMockValues();
    return of(mockDiagnosticsValues.skippedStudentsList).pipe(delay(500));
  }

  GetDiagnosticDataForTeacher(): Observable<DiagnosticsVM[]> {
    var mockDiagnosticsValues = new DiagnosticsDataServiceMockValues();
    return of(mockDiagnosticsValues.diagnosticsData).pipe(delay(500));
  }

  GetDiagnosticDataForAdminByTeacherID(teacherID: number): Observable<DiagnosticsVM[]> {
    var mockDiagnosticsValues = new DiagnosticsDataServiceMockValues();
    return of(mockDiagnosticsValues.diagnosticsData).pipe(delay(500));
  }

  DiagnosticLessonsSkipStudent(model: DiagnosticLessonsSkipStudentModel): Observable<boolean> {
    return of(true).pipe(delay(500));
  }

  GetDiagnosticDataByDiagnosticExamID(diagnosticExamID: number): Observable<DiagnosticVM> {
    var mockDiagnosticsValues = new DiagnosticsDataServiceMockValues();
    return of(mockDiagnosticsValues.diagnosticData).pipe(delay(500));
  }

  GetDiagnosticListForTeacher(hbcID? : number): Observable<DiagnosticsList[]> {
    var mockDiagnosticsValues = new DiagnosticsDataServiceMockValues();
    var url = hbcID ? 'teacherid is not null:' + hbcID : 'teacherid null';
    return of(mockDiagnosticsValues.diagnosticsList).pipe(delay(500));
  }

  GetClassListByTeacher(): Observable<ClassForListing[]> {
    var cList = new ClassListByTeacherID();
    return of(cList.classList).pipe(delay(1000));
  }

  GetClassListByTeacherAndStudentID(studentID: number): Observable<ClassForListing[]> {
    var cList = new ClassListByStudentAndTeacherID();
    return of(cList.classList).pipe(delay(1000));
  }

  ReassignStudent(model: ReassignStudentModel): Observable<boolean> {
    return of(true);
  }

  LockAssignmentForStudent(model: LessonProgressLockSaveModel): Observable<boolean> {
    return of(true);
  }

  SaveGradeForStudent(model: LessonProgressSaveGradeModel): Observable<boolean> {
    return of(true);
  }

  ReleaseGradeForStudent(model: LessonProgressSaveModel): Observable<boolean> {
    return of(true);
  }

  ReleaseKeyForStudent(model: LessonProgressSaveModel): Observable<boolean> {
    return of(true);
  }

  ReleaseAllGradesByStudentID(model: LessonProgressReleaseAllByStudent): Observable<boolean> {
    return of(true);
  }

  ReleaseAllGradesByAssignmentID(model: LessonProgressReleaseAllByAssignment): Observable<boolean> {
    return of(true);
  }

  GetLessonProgressByStudentAndLessonVersionID(classid: number, studentid: number, Lessonversionid: number): Observable<StudentVM> {
    var studentData = new StudentAndAssignmentData();
    return of(studentData.studentassignmentdata).pipe(delay(1000));
  }

  GetLessonProgressByStudentID(classid: number, studentid: number): Observable<StudentVM> {
    var studentData = new StudentData();
    return of(studentData.studentData).pipe(delay(1000));
  }

  GetLessonProgressByLessonVersionID(classid: number, lessonversionid: number): Observable<AssignmentVM> {
    var assignmentData = new AssignmentData();
    return of(assignmentData.assignmentData).pipe(delay(1000));
  }

  GetLessonProgressByClassID(classid: number): Observable<GradebookVM> {
    // Deep Shah use gradebookDataNullGrade after testing gradebookData1AssignmentFor1StudentWithUnitID
    return of(this.gradebookData.newGradebookDataForIntegrationTesting).pipe(delay(1000));
    //return of(this.gradebookData.gradebookData1AssignmentFor1StudentWithUnitID).pipe(delay(1000));
    // return of(this.gradebookData.gradebookDataNullGrade).pipe(delay(1000));
  }





  GetLessonByID(lessonid: number): Observable<Lesson> {
    let l = new Lesson();
    l.LessonID = 1;
    l.LessonVersionID = 1;
    l.Name = "Introduction to Psychological Perspectives";
    return of(l);
  }
  GetStudentLessons(lessonid: number): Observable<StudentLesson[]> {
    return of(this.studentLessons.studentLessons);
  }

  LoginAsStudent(model: LoginAsStudentModel): Observable<boolean>{
    return of(true);
  }

  GetStudentLesson(model: SelfServiceGetLessonModel): Observable<SelfGetLessonReturnModel>{
    return of({
      Success: true,
      ErrorMessage: "",
      AssignmentID: 13453453
    });
  }

  LoginAndGetStudentDemo(model: SelfServiceGetLessonModel): Observable<SelfGetLessonReturnModel>{
    return of({
      Success: true,
      ErrorMessage: "",
      AssignmentID: 13453453
    });
  }

  GetELearningDashboardState(): Observable<string> {
    var state = this.savedState;
    return of(state);
  }

  SaveELearningDashboardState(state: ELearningDashboardState): Observable<boolean> {
    return of(true);
  }

  SetServiceFactory(service: IServiceFactory): void {
    return;
  }

    UpdateDashboardVisibility(HBClassID: number, visibility: boolean): Observable<boolean> {

        return of(true);
    }

    GetClassesForTeacher(): Observable<ELearningDashboardClass[]> {

      if(!this.isAdmin){
        return of(this.teacherData.classes)
      }
        return of([]);
    }

    GetTeachersForAdmin(): Observable<Teachers> {

      if(this.isAdmin){
        // return of(this.testData.teachers);
        return of(this.adminData.teachers);
      }
      return of(this.teacherData.teachers);
    }

    GetClassesForAdminFromTeacherID(teacherID: number): Observable<ELearningDashboardClass[]> {

      if(this.isAdmin){
        return of(this.adminData.classesFromTeacherID).pipe(delay(3000));
         //return of([]);
      }

      return of([]).pipe(delay(3000));
    }

    GetLinksForAdmin(): Observable<number[]> {

        return of(this.adminLinks).pipe(delay(3000));
    }

    GetAllGradebookDataForUser() {
      var mockValues = new GradebookDataServiceMockValues();
      return mockValues.getDataArray();
    }

    //Janak
    CreateAssignments(data: CreateAssignmentsModel ): Observable<boolean> {
      return of(true).pipe(delay(3000));
    }

    GetDefaultAssignmentOptions(): Observable<CreateAssignmentOptions> {
      var cList = new CreateAssignment();
      return of(cList.CreateAssignmentDefaultData).pipe(delay(3000));
    }

    GetClassesWithStudent(): Observable<ClassWithStudentsForListing[]> {
      var cList = new CreateAssignment();
      return of(cList.ClassListingForTeacher).pipe(delay(1000));
    }

    GetClassWithStudents(classID: number): Observable<ClassWithStudentsForListing> {
      var cList = new CreateAssignment();
      return of(cList.ClassListingForAdmin).pipe(delay(1000));
    }

    CreateAccount(data: CreateAccountModel ): Observable<boolean> {
      return of(true).pipe(delay(1000));
    }

    GetUserDetailsForEdit(): Observable<CreateAccountModel> {
      var cList = new CreateAccountServiceMockValues();
      return of(cList.userData).pipe(delay(3000));
    }

    EditUser(data: CreateAccountModel ): Observable<boolean> {
      return of(true).pipe(delay(3000));
    }

    GetCurriculumData(): Observable<CurriculaVMModel> {
      var cList = new CurriculumServiceMockValues();
      return of(cList.curriculumData).pipe(delay(1000));
    }

    AssignCurriculum(data: ExistingStudentCurriculumRegisterModel ): Observable<PaymentProviderRequestResult> {
      var successModel: PaymentProviderRequestResult = {
        Success: true,
        RequestUrl: "http://www.google.com",
        ResultMessage: "Success"
      }

      var failureModel: PaymentProviderRequestResult = {
        Success: false,
        RequestUrl: null,
        ResultMessage: "There was an issue recogulating the binabulator during realignment of the basal space flange."
      }

      return of(successModel).pipe(delay(3000));
    }

    AssignCurriculumForStudentConsumerCurriculum(model: ExistingStudentConsumerCurriculumRegisterModel): Observable<PaymentProviderRequestResult> {
      var successModel: PaymentProviderRequestResult = {
        Success: true,
        RequestUrl: "http://www.google.com",
        ResultMessage: "Success"
      }

      var failureModel: PaymentProviderRequestResult = {
        Success: false,
        RequestUrl: null,
        ResultMessage: "There was an issue recogulating the binabulator during realignment of the basal space flange."
      }

      return of(successModel).pipe(delay(3000));
    }
  

    GetStudentList(): Observable<StudentModel[]> {
      var cList = new CurriculumServiceMockValues();
      //return of(cList.studentData).pipe(delay(3000));
     return of([]);
    }

    GetSelectedCurriculum(curriculumID: number): Observable<SelectedCurriculumModel> {
      var cList = new CurriculumServiceMockValues();
      return of(cList.selectedCurriculumData).pipe(delay(3000));
    }

    RegisterNewStudent(model: RegisterNewStudent ): Observable<number> {
      return of(123).pipe(delay(3000));
    }

    GetStudentCourseList(): Observable<StudentCourseModel> {
      var cList = new CurriculumServiceMockValues();
      return of(cList.studentCourseData).pipe(delay(3000));
    }

    GetCurriculumViewDataByClassId(classID: number): Observable<CurriculumViewListing> {
      var cList = new CurriculumServiceMockValues();
      return of(cList.currViewData).pipe(delay(3000));
    }

    GetRedirectModelFromProcessPaymentFailure(guid: string): Observable<PaymentFailureRedirectModel> {
      var model: PaymentFailureRedirectModel = {
        CurriculumID: 5,
        StudentID: 5,
        CurriculumProductLevelID: 2
      }

      return of(model).pipe(delay(3000));
    }

    GetRedirectModelFromProcessPaymentSuccess(guid: string): Observable<PaymentSuccessRedirectModel> {
      var successModel: PaymentSuccessRedirectModel = {
        ClassID: 1,
        Success: true
      };

      var failureModel: PaymentSuccessRedirectModel = {
        ClassID: 1,
        Success: false
      }

      return of(successModel).pipe(delay(3000));
    }
  
    LoginUser(data: LoginAccountModel): Observable<LoginAccountResult> {
      var model = new LoginAccountResult();
      model.isLoggedIn = true;
      return of(model).pipe(delay(3000));
    }

    GetStudentConsumerCurriculum(StudentID: number, curriculumID: number): Observable<StudentConsumerCurriculum> {
      var model: StudentConsumerCurriculum = {
        ID: 1,
        StudentUserID: 1,
        HBClassID: 1,
        CurriculumID: 1,
        CustID: 1,
        ConsumerCurriculumID: 1,
        HasDemoCompleted: false,
        HasCompletedPreCourseDiagnostic: false,
        PurchaseDate: null,
        ReadOnly: false,
        Active: true,
      }

      var noModel = null;

       return of(noModel).pipe(delay(3000))
      //return of(model);
    }

    GetDemoResultData(studentConsumerCurriculumID: number): Observable<DemoResultData> {
      var mocks = new MockDemoResults()
      return of (mocks.marketingReport).pipe(delay(3000));
    }

    GetDemoResultDataByStudentAndClass(studentID: number, classID: number): Observable<DemoResultData> {
      var mocks = new MockDemoResults()
      return of (mocks.marketingReport).pipe(delay(3000));
    }

    ValidateParentPassword(pass: string): Observable<boolean> {
      return of (true).pipe(delay(3000));
    }

    GetIsTeacher(): Observable<boolean> {
      return of (false).pipe(delay(3000));
    }

  GetStandardsGrowthReport(classid: number): Observable<StandardsGrowthReportModel>{
    var Standards = new CurriculumServiceMockValues();
    return of(Standards.globalStandards);
  }

  GetAssignmentAttemptsForViewWorkDialog(studentID: number, assignmentID: number): Observable<ViewWorkDialogAssignmentAttempt[]>{
    var aas = new ViewWorkDataServiceMockValues();
    return of(aas.viewWorkAssignmentAttemptsDiaglog).pipe(delay(3000));
  }
}
